import {
  formatNumber,
  getCountryCallingCode,
  parsePhoneNumberFromString
} from 'libphonenumber-js/custom'
import metadata from './metadata.min.json'
/**
 * https://www.npmjs.com/package/libphonenumber-js/v/0.3.3#customizing-metadata
 */

export function formatPhone() {
  var parameters = Array.prototype.slice.call(arguments)
  parameters.push(metadata)
  return formatNumber.apply(this, parameters)
}

export function getCallingCode() {
  var parameters = Array.prototype.slice.call(arguments)
  parameters.push(metadata)
  return getCountryCallingCode.apply(this, parameters)
}

export function parsePhoneNumberFromText() {
  var parameters = Array.prototype.slice.call(arguments)
  parameters.push(metadata)
  return parsePhoneNumberFromString.apply(this, parameters)
}
